import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Typography from 'material-ui/Typography'
import Card, { CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import ResistanceUnbalnceSubtest from '../resistanceunbalancetest'
import {
  metersToFeet,
  picofaradsUnitConversion,
  getFormattedNumber
} from '../../../../../../common/utils'
class TabularSubtest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      direction: 'row', 
      justify: 'center',
      alignItems: 'center'
    }
  }

  lengthUnitConverter = length => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    return getFormattedNumber(length)
  }

  picofaradUnitConverter = (length, unitType) => {
    if (unitType === 'pF/ft') {
      return picofaradsUnitConversion(length, unitType)
    }
    return getFormattedNumber(length)
  }

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtestResultsRemote,
      subtest,
      subtestRes
    } = this.props
    let testresult, data, margin

    if (subtest === 'HeadRoom' && subtestRes) {
      testresult = subtestRes
      data = testresult ? testresult.worst : null
      margin = testresult ? testresult.worst : null
      testresult.pairs = testresult ? testresult.worst ? [testresult.worst.pair] : [] : []
      testresult.data = testresult ? testresult.worst ? [testresult.worst.margin] : [] : []
    } else {
      testresult = results.data.lfttest.find(x => x.subtesttypeid === subtest)
      data = testresult ? testresult.data[0] : null
      margin = testresult ? testresult.margin : null
    }
    const { alignItems, direction, justify } = this.state
    if (
      results.data.devicetype === 'Comet' &&
      subtest === 'ResistanceUnBalancedPair'
    ) {
      data = null
    }
    if (data) {
      let pairs = testresult.pairs
      let NVP = testresult.NVP;
      const measurementUnit = chartMeasurementUnit === 'feet' ? '(ft)' : '(m)'

      const limitIdx = pairs.findIndex(x => x === 'Limit')
      pairs = limitIdx !== -1 ? pairs.slice(0, -1) : pairs
      let limitVal = data[limitIdx]
        ? testresult.unit === 'm' || testresult.unit === 'pF'
          ? this.lengthUnitConverter(data[limitIdx])
          : data[limitIdx]
        : 0
      let unittype = testresult.unit
      if (testresult.unit === 'm' || testresult.unit === 'pF') {
        if (testresult.unit === 'm') {
          unittype = chartMeasurementUnit === 'feet' ? 'feet' : 'meters'
        }
        if (testresult.unit === 'pF') {
          unittype = chartMeasurementUnit === 'feet' ? 'pF/ft' : 'pF/m'
        }
      }
      let lengthUnitType = (unittype && unittype !== 'feet' && unittype !== 'ft') ? translate(unittype) : ''

      let _unittype = testresult.unit
      if (testresult.unit === 'm' || testresult.unit === 'pF') {
        if (testresult.unit === 'm') {
          _unittype = chartMeasurementUnit === 'feet' ? 'ft' : 'm'
        }
        if (testresult.unit === 'pF') {
          _unittype = chartMeasurementUnit === 'feet' ? 'pF/ft' : 'pF/m'
        }
      }
      let _lengthUnitType = (_unittype && _unittype !== 'feet' && _unittype !== 'ft') ? translate(_unittype) : ''

      let impedancePair = {}
      if (subtest === 'Impedance') {
        for (let index in pairs) {
          if (pairs[index] === 'Max') {
            impedancePair = { ...impedancePair, Max: index }
          }
          if (pairs[index] === 'Min') {
            impedancePair = { ...impedancePair, Min: index }
          }
        }
        pairs = pairs.filter((value, key) => {
          return !['Min', 'Max'].includes(value)
        })
      }

      let headroomHeader = translate("general_values");

      if (subtest === 'HeadRoom') {
        headroomHeader = translate("rfsubtest_margin");                              
      }
      return (
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            <Grid
              container
              spacing={16}
              className={classes.subtestHeight}
              alignItems={alignItems}
              direction={direction}
              justify={justify}
            >
              <Grid item className={classes.tableContainer}>
                <Table>
                  <TableHead>
                    <TableRow className={classes.tablerow}>
                      <TableCell className={classes.tableheader}>
                        {translate("general_pairs")}
                      </TableCell>
                      <TableCell numeric className={classes.tableheader}>
                      {translate("general_values")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pairs.map((pair, key) => {
                      let val
                      if (subtest === 'HeadRoom') {
                        val = data.margin
                      } else val = data[key]
                      return (
                        <TableRow key={key} className={classes.tablerow}>
                          <TableCell
                            component='th'
                            scope='row'
                            className={classes.tableheader}
                          >
                            {pair}
                          </TableCell>
                          <TableCell numeric className={classes.tableheader}>
                            {testresult.unit === 'pF'
                              ? this.picofaradUnitConverter(
                                data[key],
                                _unittype
                              )
                              : testresult.unit === 'm'
                                ? this.lengthUnitConverter(data[key])
                                : getFormattedNumber(val)}
                            {' ' + _lengthUnitType}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Grid>
              {!['Impedance', 'HeadRoom'].includes(subtest) &&
                <Grid item>
                  <Typography className={ ['Length'].includes(subtest)?classes.limitNVP: classes.button}>{translate("general_limit")}</Typography>
                  <Typography className={classes.title} gutterBottom>
                    {testresult.unit === 'pF'
                      ? data[limitIdx]
                        ? `<${this.picofaradUnitConverter(data[limitIdx], _unittype)}`
                        : <span className={classes.hyphen}>-</span>
                      : data[limitIdx]
                        ? (measurementUnit == '(ft)' && subtest === 'Length') ? limitVal : `<${getFormattedNumber(limitVal)}`
                        : <span className={classes.hyphen}>-</span>}
                  </Typography>
                  <Typography className={classes.button} gutterBottom>
                    {lengthUnitType}
                </Typography>
                {
                  ['Length'].includes(subtest) &&
                  <Typography className={ classes.NVP } gutterBottom>
                     { "NVP "+" " }
                     { NVP!=null ? NVP+"%" : "-" }
                </Typography>
                }
                </Grid>}
              {['Impedance'].includes(subtest) &&
                <Grid item>
                  <Typography className={classes.button}>{translate("general_limit")}</Typography>
                  {Object.keys(impedancePair).map(key => {
                    return (
                      <Typography className={classes.impedancePair}>
                        <Typography className={classes.impedancePairTitle}>
                          {key == "Max" ? translate('impedence_max') : translate('impedence_min')}
                        </Typography>
                        <Typography className={classes.impedancePairValue}>
                          {getFormattedNumber(data[impedancePair[key]])}
                        </Typography>
                      </Typography>
                    )
                  })}
                  <Typography className={classes.button} gutterBottom>
                    {unittype && translate(unittype)}
                  </Typography>
                </Grid>}
            </Grid>
          </Grid>
        </Grid>
      )
    } else {
      return (
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            <Grid
              container
              spacing={16}
              className={classes.demo}
              alignItems={alignItems}
              direction={direction}
              justify={justify}
            >
              <Grid item>
                <Typography className={classes.title} gutterBottom>
                  {subtest === 'ResistanceUnBalancedPair'
                    ? <ResistanceUnbalnceSubtest
                      translate={translate}
                      results={results}
                      subtest={subtest}
                    /> : ''}
                </Typography>
              </Grid>

            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
}

export default withStyles(styles)(TabularSubtest)
